import { render, staticRenderFns } from "./mct-template.vue?vue&type=template&id=6c0f8f58&"
import script from "./mct-template.vue?vue&type=script&lang=js&"
export * from "./mct-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports